import React, { Fragment } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { AccountDetailsStepValues } from "../../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationSignUpFlowValues } from "../../_interfaces/IOrganizationSignUpFlowValues";
import { RegistrationCredentialsForm } from "../../../../authentication/components/RegistrationCredentialsForm";
import { OrganizationSignUpHeader } from "../OrganizationSignUpHeader";
import { useAccountDetailsController } from "../../hooks/useAccountDetailsController";
import { BackButton } from "./BackButton";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            maxWidth: `calc(40ch + ${theme.spacing(2)}px)`,
            margin: 'auto'
        }
    })
);

export const AccountDetailsStep: React.FC<
    StepRenderProps<AccountDetailsStepValues, IOrganizationSignUpFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useAccountDetailsController(values, allValues, update, submit);

    /********* Render *********/

    return (
        <Fragment>
            <OrganizationSignUpHeader />
            <div className={classes.wrapper}>
                <RegistrationCredentialsForm
                    values={controller.values}
                    onChange={(patch) => {
                        controller.onChange(patch);
                        update(patch); // sync with Flow
                    }}
                    onSubmit={controller.onSubmit}
                    isSubmitting={controller.isSubmitting}
                    error={controller.error}
                    fieldErrors={controller.fieldErrors}
                />
            </div>
            <BackButton
                onClicked={() => controller.onSubmit({ backClicked: true })}
                isSubmitting={controller.isSubmitting}
            />
        </Fragment>
    );
});